import { createRouter, createWebHistory } from 'vue-router'
import LoginView2 from '../views/LoginView2.vue'
import DashboardView from '../views/DashboardView.vue'
import NoticeBoard from '@/views/NoticeBoard.vue'
import QABoard from '@/views/QABoard.vue'
import TwoFrameChatView from '@/views/TwoFrameChatView.vue'
import MainView from '@/views/MainView.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import MainViewPub from '@/views/MainViewPub.vue'
import ChatPub from '@/views/ChatPub.vue'
import PageLayout from '@/layouts/PageLayout.vue'
import MainViewInt from '@/views/MainViewInt.vue'
// 2025.01.03 
import QABoardPub from '@/views/QABoard/QABoardPub.vue'
import QARegister from '@/views/QABoard/QARegister.vue'
import QADetail from '@/views/QABoard/QADetail.vue'

// 20250414
import INSIGHTBoard from '@/views/INSIGHT/INSIGHTBoard.vue'
import INSIGHTRegister from '@/views/INSIGHT/INSIGHTRegister.vue'
import INSIGHTDetail from '@/views/INSIGHT/INSIGHTDetail.vue'

import KWNotificationList from '@/views/KeyWordNotification/NotificationList.vue'
import NotificationRegister from '@/views/KeyWordNotification/NotificationRegister.vue'

import DashboardMain from '@/views/Dashboard/DashboardMain.vue'


import StatusBoard from '@/views/StatusBoard/StatusBoard.vue'

const routes = [
 {
  path: '/',
  name: 'login',
  component: LoginView2
 },
 {
  path: '/pub',
  component: PageLayout,
  children: [
   {
    path: '',
    name: 'MainPub',
    component: MainViewPub
   },
   {
    path: 'chat',
    name: 'ChatPub',
    component: ChatPub
   },
   {
      path: 'qa',
      name: 'QAPub',
      component: QABoardPub,
      meta: { requiresAuth: true }
   },
   {
      path: 'StatusBoard',
      name: 'StatusBoard',
      component: StatusBoard,
      meta: { requiresAuth: true }
   },
   {
      path: 'qa/register',
      name: 'QARegister',
      component: QARegister,
      meta: { requiresAuth: true }
    },
    {
      path: 'qa/detail/:qa_id',
      name: 'QADetail',
      component: QADetail,
      meta: { requiresAuth: true }
    },
    {
      path: 'insight',
      name: 'INSIGHTBoard',
      component: INSIGHTBoard,
      meta: { requiresAuth: true }
   },
   {
    path: 'insight/register',
    name: 'INSIGHTRegister',
    component: INSIGHTRegister,
    meta: { requiresAuth: true }
   },
   {
    path: 'insight/detail/:insight_id',
    name: 'INSIGHTDetail',
    component: INSIGHTDetail,
    meta: { requiresAuth: true }
  },
  {
      path: 'notification/:project_id',
      name: 'Notification',
      component: KWNotificationList,
      meta: { requiresAuth: true }
  },
  {
    path: 'notification/register',
    name: 'NotificationRegister',
    component: NotificationRegister,
    meta: { requiresAuth: true }
   },
   {
      path: 'dashboardMain/:project_id',
      name: 'DashboardMain',
      component: DashboardMain,
      meta: { requiresAuth: true }
  },
  {
      path: 'prompt-recommend',
      name: 'PromptRecommendPage',
      component: () => import('@/views/Dashboard/PromptRecommendPage.vue'),
      meta: { requiresAuth: true }
  }
  
  ]
 },
 {
  path: '/app',
  component: DefaultLayout,
  children: [
   {
    path: 'main',
    name: 'Main',
    component: MainView,
    meta: { requiresAuth: true }
   },
   {
    path: 'chat',
    name: 'Chat',
    component: TwoFrameChatView,
    props: route => ({
     //selectedJobs: JSON.parse(route.params.selectedJobs || '[]')
        selectedJobs: route.query.selectedJobs ? JSON.parse(route.query.selectedJobs) : [],
        sessionId: route.query.sessionId ? Number(route.query.sessionId) : null,
    }),
    meta: { requiresAuth: true }
   },
   {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
   },
   {
    path: '/notices',
    name: 'Notices',
    component: NoticeBoard,
    meta: { requiresAuth: true }
   },
   {
    path: 'qa',
    name: 'QA',
    component: QABoard,
    meta: { requiresAuth: true }
   }
  ]
 },
 {
  path: '/register',
  name: 'register',
  component: () => import('../views/RegisterView.vue')
 }
]

const router = createRouter({
 history: createWebHistory(import.meta.env.BASE_URL),
 routes
})

// Navigation guard
// router.beforeEach((to, from, next) => {
//  const isAuthenticated = !!localStorage.getItem('access_token')
//  console.log('Navigation guard - isAuthenticated:', isAuthenticated)
//  console.log('Route to:', to.name)

 
//  if (!isAuthenticated && to.path !== '/') {
//     console.log('Redirecting to login - not authenticated')
//     next({ name: 'login' })
//    } else {
//     console.log('Proceeding to:', to.name)
//     next()
//    }


//  if (to.meta.requiresAuth && !isAuthenticated) {
//   console.log('Redirecting to login - not authenticated')
//   next({ name: 'login' })
//  } else if (to.name === 'login' && isAuthenticated) {
//   console.log('Redirecting to MainPub - already authenticated')
//   next({ name: 'MainPub' })
//  } else {
//   console.log('Proceeding to:', to.name)
//   next()
//  }
// })

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('access_token')
  console.log('Navigation guard - isAuthenticated:', isAuthenticated)

  if (to.meta.requiresAuth && !isAuthenticated) {
    console.log('🔒 인증 필요 → 로그인 이동')
    return next({ name: 'login' })
  }

  if (to.name === 'login' && isAuthenticated) {
    console.log('✅ 로그인 상태 → 메인으로 리디렉션')
    return next({ name: 'MainPub' })
  }

  return next() // ✅ 마지막에 딱 한 번만 호출
})

export default router
